import React, {useState} from 'react';
import {Logo} from "../../../icons/icons";
import {useTranslation} from "react-i18next";
import CustomInput from "../../../components/UI/customInput/customInput";
import {Link, redirect, useNavigate, useParams, useSearchParams} from "react-router-dom";
import CustomButton from "../../../components/UI/customButton/customButton";
import AppSection from "../../../components/appSection/app-section";
import Timer from "../../../components/timer/Timer";
import {Post} from "../../../apis/api";
import {toggleAuth} from "../../../store/user/user.reducer";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";
import {setPermissions} from "../../../store/permissions/permissions.reducer";

const Index = () => {
  const {t} = useTranslation()
  const [type , setType] = useState(1)
  const [form, setForm] = useState({})
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();

  const handleForm = ({name, value}) => {
    setForm((prevState) => ({...prevState, [name]: +value}))
  }
  const dispatch = useDispatch()

  const handleSubmitOtp = () => {
    setLoading(true)
    if(searchParams.get("mobile")) {
      Post("verify-code" , {...form , mobile:searchParams.get("mobile") }).then((res) => {
        dispatch(toggleAuth(res?.details))
        dispatch(setPermissions(res?.details?.permissions));
        navigate("/");
      }).catch((error) => {
        toast.error(error.data.message || error.data.msg)
      }).finally(() => {
        setLoading(false)
      })
    } else {
      Post("forget-password/verify-code" , {...form , email:searchParams.get("email") }).then((res) => {
        dispatch(toggleAuth(res?.details))
        dispatch(setPermissions(res?.details?.permissions));
        navigate(`/auth/new-password/?email=${searchParams.get("email")}&code=${form.code}`);
      }).catch((error) => {
        toast.error(error.data.message || error.data.msg)
      }).finally(() => {
        setLoading(false)
      })
    }
  }
  return (
    <div className={"flex flex-col justify-center items-center mt-10 mb-10 md:mb-0 md:mt-20"}>
          <div className={"rounded-lg bg-white p-5 py-10 flex items-center justify-center flex-col w-[350px]  gap-5 shadow-2xl rounded-lg"}>
            <Logo/>
            <span className={"text-gray-900 text-sm text-center"}>{t("otpTitle")}</span>
            <div>
              <Timer/>
            </div>
            <CustomInput
              placeHolder={t('oneTime')}
              label={t('oneTime')}
              name={`code`}
              onchange={(e) => handleForm(e)}
            />

            <CustomButton onClick={handleSubmitOtp} loading={loading} title={t("loginToAccount")}/>
            <div className={"w-full gap-4 flex justify-center cursor-pointer"}>
              <div onClick={() => setType(2)}>
               <Link  className={"text-gray-500 text-xs text-end w-full"}>
                  {t("sendAgan")}
               </Link>
              </div>
              <div onClick={() => setType(2)}>
               <Link to={"/auth/login"} className={"text-main text-xs text-end w-full"}>
                  {t("oneTimePassword")}
               </Link>
              </div>
            </div>
          </div>
      <AppSection/>
    </div>
  );
};

export default Index;
